/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc 购物车
 */
import lodash from 'lodash';
import { computed } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BaseModel, BasesController } from '../bases';

export class CartController<T = any> extends BasesController<T> {
  constructor() {
    super();
    this.reset({
      dataKey: 'vendorCode',
      // infinite: true,
      insert: EnumAPI.orders_cart_add,
      delete: EnumAPI.orders_cart_delete,
      pagination: EnumAPI.orders_cart,
      paginationParams: {},
    });
  }
  CartModel = new BaseModel({ type: 'object' });
  /**
   * 购物车数量
   */
  get cartNum() {
    return lodash.get(this.CartModel.value, 'cartNum');
  }
  /**
   * 展开的购物车全部商品数据
   */
  @computed
  get dataSourceProduct() {
    return lodash.flatten(
      lodash.map(this.Pagination.dataSource, 'cartProductList'),
    );
  }

  /**
   * 展开的购物车无效商品
   */
  @computed
  get dataSourceOverdueProduct() {
    return lodash.filter(this.dataSourceProduct, ['isSold', false]);
  }
  /**
   * 展开的购物车有效商品
   */
  @computed
  get dataSourceEffectiveProduct() {
    return lodash.filter(this.dataSourceProduct, ['isSold', true]);
  }
  /**
   * 已勾选的商品
   */
  @computed
  get dataSourceSelected() {
    return lodash.filter(this.dataSourceEffectiveProduct, (item) =>
      lodash.some(this.Pagination.selectedRowKeys, (key) =>
        lodash.eq(key, item.id),
      ),
    );
  }
  /**
   * 总价格
   */
  @computed
  get totalPrice() {
    const selected = this.dataSourceSelected;
    const total = lodash.multiply(
      lodash.sumBy(selected, 'productSubTotalPrice'),
      100,
    );
    return lodash.ceil(total, 2);
  }
  /**
   * 更改商品数量
   * @param {*} entity
   * @param {*} productNum
   * @memberof CartController
   */
  async onChangeNum(entity, productNum) {
    try {
      if (lodash.eq(lodash.get(entity, 'productNum'), productNum)) {
        return;
      }
      const res = await AjaxBasics.request<{ changedPrice: number }>(
        lodash.assign(
          {
            body: {
              count: productNum,
              id: lodash.get(entity, 'id'),
              productId: lodash.get(entity, 'productId'),
              productType: lodash.get(entity, 'productType'),
            },
          },
          EnumAPI.orders_cart_change,
        ),
      );
      // 查找 当前商品对应的分组数据
      const data = lodash.find<any>(this.dataSource, [
        'vendorCode',
        entity.vendorCode,
      ]);
      const path = lodash.findIndex(lodash.get(data, 'cartProductList'), [
        'id',
        entity.id,
      ]);
      // 更改 当前分组数据下的 商品数量
      lodash.update(data, `cartProductList[${path}]`, (old) =>
        lodash.merge(old, {
          productNum,
          productSubTotalPrice: res.changedPrice,
          // 配件数量
          productPartsList: lodash.map(old.productPartsList, (item) =>
            lodash.merge(item, {
              productNum: productNum * item.pieNum,
            }),
          ),
        }),
      );
      this.Pagination.onUpdate(data);
    } catch (error) {
      throw error;
    }
  }
  /**
   * 单选 全选
   * @param toggle
   * @returns
   */
  toggleChecked(toggle) {
    let selectedRowKeys = [...this.Pagination.selectedRowKeys];
    if (lodash.isBoolean(toggle)) {
      // 全选
      if (lodash.eq(toggle, true)) {
        selectedRowKeys = lodash.map(this.dataSourceEffectiveProduct, 'id');
      } else {
        selectedRowKeys = [];
      }
    } else {
      const { id, isSold } = toggle;
      if (!isSold) return;
      // 反选
      if (this.isChecked(toggle)) {
        lodash.remove(selectedRowKeys, (item) => lodash.eq(item, id));
      } else {
        selectedRowKeys.push(id);
      }
    }
    this.Pagination.onSelectChange(selectedRowKeys);
  }
  /**
   * 当前商品是否选中
   * @param entity
   * @returns
   */
  isChecked(entity) {
    return lodash.includes(this.Pagination.selectedRowKeys, entity.id);
  }
  /**
   * 全选
   * @returns
   */
  isCheckedAll() {
    const selectedSize = lodash.size(this.Pagination.selectedRowKeys);
    if (selectedSize) {
      return lodash.eq(
        selectedSize,
        lodash.size(this.dataSourceEffectiveProduct),
      );
    }
  }
  checkIs86OrR3HasErr(arr) {
    if (arr.length > 0) {
      let filterArr = arr.filter(function (item) {
        let is86OrR3 =
          item.productGroupCode === '86' || item.productGroupCode === 'R3';
        return is86OrR3;
      });
      if (filterArr.length > 0 && filterArr.length !== arr.length) {
        return true;
      }
    }
    return false;
  }
  /**
   * 检查结算
   * @return {*}
   * @memberof CartController
   */
  isCheckClearing() {
    const dataSource = this.dataSourceSelected;
    const data = lodash.filter(dataSource, [
      'vendorCode',
      lodash.get(dataSource, '[0].vendorCode'),
    ]);
    if (dataSource.length <= 0) {
      throw '请选择商品结算';
    }
    // 校验起订量
    checkMinOrderQuantity(dataSource);
    console.log('dataSource', dataSource);
    if (!lodash.eq(data.length, dataSource.length)) {
      throw '产品交付服务商不唯一，不能与其他产品一起下单';
    }
    if (this.checkIs86OrR3HasErr(dataSource)) {
      throw 'R3和86产品组不支持和其他产品组同时下单';
    }
    return true;
  }
  /**
   *验证活动库存
   * @param {*} product
   * @memberof CartController
   */

  async verifyActive(product) {
    try {
      let orderProductInfoList = lodash.map(product, (item) => ({
        shoppingCartId: item.id,
        productId: item.productId,
        commodityQuantity: item.productNum,
      }));
      return await AjaxBasics.request<any>({
        ...EnumAPI.car_verifyActive,
        body: { orderProductInfoList },
      });
    } catch (error) {
      throw error;
    }
  }
  /**
   *立即预约
   * @param {*} params
   * @memberof CartController
   */

  async onReserve(params) {
    try {
      return await AjaxBasics.request<any>({
        ...EnumAPI.product_reserve,
        body: params,
      });
    } catch (error) {
      throw error;
    }
  }

  /**
   *购物车角标
   * @memberof CartController
   */
  async onCartProductTotalNum() {
    try {
      const res = await AjaxBasics.request<any>({
        ...EnumAPI.product_cartProductTotalNum,
      });
      this.CartModel.merge({ cartNum: res });
    } catch (error) {
      throw error;
    }
  }
}

// 校验起订量
function checkMinOrderQuantity(dataSource: any[]) {
  dataSource.forEach((product) => {
    const minOrderQuantity = product.minOrderQuantity || 1;
    if (product.productNum < minOrderQuantity) {
      throw `该商品（${product.productName}）最小起订数量为${minOrderQuantity}，请调整订单商品数量！`;
    }
  });
}
